import { useEffect, useState, useRef } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { selectEssSwitch } from "shared/slice/essSwitchSlice";
import { selectTesSwitch } from "shared/slice/tesSwitchSlice";
import { getSSRsForDeviceService } from "shared/services";
import { ssrStateKey } from "shared/hooks/useSsrState";
import { buildSsrStateFromRest } from "shared/helpers/ssrCache";
import { useSsrElementsBank } from "./useSsrElementsBank";
import { buildSpecsFromHeaters } from "shared/helpers/buildSpecsFromHeaters";

export const useGetSSRsQueries = (location, machine, swtName) => {
  const queryClient = useQueryClient();

  const { elementsOptions } = useSsrElementsBank();
  const { flatEssSwitch, flatTesSwitch } = useSelector(
    swtName === 'ESS'
      ? selectEssSwitch
      : selectTesSwitch
  );

  const swtStatus = swtName === 'ESS' ? flatEssSwitch : flatTesSwitch;

  const [fetchSSRs, setFetchSSRs] = useState(false);
  const initialFetch = useRef(false);

  useEffect(() => {
    if (elementsOptions.length > 0 && !initialFetch.current) {
      setFetchSSRs(true);
      initialFetch.current = true;
    }
  }, [elementsOptions]);

  const getSSRsQueries = useQuery(
    [machine, '-ssrsData'],
    () => getSSRsForDeviceService(machine),
    {
      enabled: fetchSSRs,
      onSuccess: (data) => {

        if (data) {

          const result = data.map((item) => {


            const specs = buildSpecsFromHeaters(item.Heaters, elementsOptions);






            return {
              ...item,
              select: `tc-${swtStatus[location][machine].heaterThermocoupleMap[item.No]}`,
              buttonStatus: item?.fault === true || item?.Load_exceeded === true ? 'flt' :
                item?.active === true ? 'on' : 'off',
              specs: specs.length !== 0 ? specs?.map((spec) => ({
                currentSSR:swtStatus[location][machine].ssr_current?.[item.No],
                ...spec,
              })) : [{}],
              switchName: `${item.name} ${item.size}`,
            };
          });

          queryClient.setQueryData(ssrStateKey(machine), (prev) =>
            buildSsrStateFromRest(prev, result)
          );
        }
      },
      onError: (error) => {
        console.error('get ssrs fail:', error.message);
      },
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 2,
    }
  );

  useEffect(() => {
    return () => {
      getSSRsQueries.remove();
    };
  }, []);

  return getSSRsQueries;
};
